"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areRangesEqual = exports.getDateRange = exports.momentStringFromDateTrunc = exports.withinRange = exports.dateAfter = exports.dateBefore = exports.areDurationsEqual = exports.rangeRelativeToDate = void 0;
var moment = require("moment");
var models_1 = require("./models");
var Accessor_1 = require("./models/Accessor");
var DataTable_1 = require("./models/DataTable");
var DateGranularity_1 = require("./models/DateGranularity");
// DateRange is fully inclusive, but in the case of relativeDateRanges, we want
// to apply an (exclusive, inclusive] range, so we adjust dateRange.first by
// the smallest unit available
var rangeRelativeToDate = function (date, relativeWindow) {
    var unitForMoment = (0, exports.momentStringFromDateTrunc)(relativeWindow.unit);
    var first = adjustDateForwardByOneMillisecond((0, exports.dateBefore)(date, relativeWindow.numberOfUnits, unitForMoment));
    return { first: first, last: date };
};
exports.rangeRelativeToDate = rangeRelativeToDate;
/**
 * This function is conservative in that if the granularites don't match exactly it returns false.
 * For example, days can not be compared to years because leap years have 366 days. Also, days
 * can't be compared to months because months have a variable number of days.
 * @param a first Duration
 * @param b second Duration
 * @returns true if Duration a is equal to Duration b
 */
var areDurationsEqual = function (a, b) {
    if (a.unit === b.unit && a.numberOfUnits === b.numberOfUnits) {
        return true;
    }
    else if ((0, DateGranularity_1.isConvertibleToSecondDateTrunc)(a.unit) && (0, DateGranularity_1.isConvertibleToSecondDateTrunc)(b.unit)) {
        return getUnitsInSeconds(a.unit, a.numberOfUnits) === getUnitsInSeconds(b.unit, b.numberOfUnits);
    }
    else if ((0, DateGranularity_1.isConvertibleToMonthDateTrunc)(a.unit) && (0, DateGranularity_1.isConvertibleToMonthDateTrunc)(b.unit)) {
        return getUnitsInMonths(a.unit, a.numberOfUnits) === getUnitsInMonths(b.unit, b.numberOfUnits);
    }
    return false;
};
exports.areDurationsEqual = areDurationsEqual;
var getUnitsInSeconds = function (dateTrunc, numberOfUnits) {
    var MINUTE_FACTOR = 60;
    var HOUR_FACTOR = 3600;
    var DAY_FACTOR = 86400;
    var WEEK_FACTOR = 604800;
    if (dateTrunc === models_1.DateTrunc.MINUTE) {
        return numberOfUnits * MINUTE_FACTOR;
    }
    else if (dateTrunc === models_1.DateTrunc.HOUR) {
        return numberOfUnits * HOUR_FACTOR;
    }
    else if (dateTrunc === models_1.DateTrunc.DAY) {
        return numberOfUnits * DAY_FACTOR;
    }
    else if (dateTrunc === models_1.DateTrunc.WEEK) {
        return numberOfUnits * WEEK_FACTOR;
    }
    return numberOfUnits;
};
var getUnitsInMonths = function (dateTrunc, numberOfUnits) {
    var QUARTER_FACTOR = 3;
    var YEAR_FACTOR = 12;
    if (dateTrunc === models_1.DateTrunc.QUARTER) {
        return numberOfUnits * QUARTER_FACTOR;
    }
    else if (dateTrunc === models_1.DateTrunc.YEAR) {
        return numberOfUnits * YEAR_FACTOR;
    }
    return numberOfUnits;
};
var adjustDateForwardByOneMillisecond = function (date) { return moment(date).add(1, 'ms').toDate(); };
var dateBefore = function (date, amount, unit) {
    return moment(date).subtract(amount, unit).toDate();
};
exports.dateBefore = dateBefore;
var dateAfter = function (date, amount, unit) {
    return moment(date).add(amount, unit).toDate();
};
exports.dateAfter = dateAfter;
var withinRange = function (range, date) { return date >= range.first && date <= range.last; };
exports.withinRange = withinRange;
var momentStringFromDateTrunc = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return 'seconds';
        }
        case models_1.DateTrunc.MINUTE: {
            return 'minutes';
        }
        case models_1.DateTrunc.HOUR: {
            return 'hours';
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return 'days';
        }
        case models_1.DateTrunc.MONTH: {
            return 'months';
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return 'weeks';
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return 'quarters';
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return 'years';
        }
        default: {
            // compare to previous point
            return undefined;
        }
    }
};
exports.momentStringFromDateTrunc = momentStringFromDateTrunc;
var getDateRange = function (table, accessor) {
    if (accessor === void 0) { accessor = Accessor_1.DefaultTimestampAccessor; }
    if (table.length === 0) {
        return undefined;
    }
    var firstPoint = table[0];
    var lastPoint = table[table.length - 1];
    var first = accessor(firstPoint);
    var last = accessor(lastPoint);
    if ((0, DataTable_1.isNullOrUndefined)(first) || (0, DataTable_1.isNullOrUndefined)(last)) {
        return undefined;
    }
    return { first: first, last: last };
};
exports.getDateRange = getDateRange;
var areRangesEqual = function (a, b) {
    return a.first.getTime() === b.first.getTime() && a.last.getTime() === b.last.getTime();
};
exports.areRangesEqual = areRangesEqual;
//# sourceMappingURL=dateUtils.js.map